<template>
  <layout-guest>
    <v-form v-model="formulario" autocomplete="off">

      <v-container class="py-8">
        <v-row class="py-8">
          <v-col cols="12">
            <main-progres />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h1 class="text-h4 font-weight-light py-5">
              {{ $t("supplierData.referenciaProvedor") }}
            </h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("supplierData.datosAccesos") }}
            </h2>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.email") }}</label>
            <v-text-field
              hint="Se usará como identificador"
              :color="entityConfig.primaryColor"
              dense
              outlined
              counter
              maxlength="50"
              max="50"
              placeholder="Email"
              v-model="form.email"
              :rules="[rules.required, rules.email]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.nombreAlias") }}</label>
            <v-text-field
             
              :rules="[rules.maxAlias, rules.minAlias]"
              counter
              maxlength="9"
              minlength="8"
              :color="entityConfig.primaryColor"
              dense
              v-model="form.alias"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.contraseña") }}</label>

            <v-text-field
              :rules="[
                rules.required,
                rules.maxPass,
                rules.minPass,
                rules.ValidatorUppercase,
                rules.ValidatorLowercase,
                rules.ValidatorHas2Number,
                rules.ValidatorNotComillas,
                rules.validatorSymbos,
                rules.validatorSymbolPermitidos,
                rules.validatorConsecutivos,
                rules.referenceValidatorHasalias,
              ]"
              counter
              maxlength="30"
              hint=""
              :color="entityConfig.primaryColor"
              dense
              outlined
              autocomplete="false"
              :type="show1 ? 'text' : 'password'"
              :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="show1 = !show1"
              v-model="form.password"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.repetirContraseña") }}</label>
            <v-text-field
              v-model="confirmPassword"
              :color="entityConfig.primaryColor"
              dense
              outlined
              :rules="passwordRules.concat(passwordConfirmationRule)"
              require
              autocomplete="false"
              hint="12 a 30 caracteres"
              max="30"
              :type="show2 ? 'text' : 'password'"
              :append-icon="show2 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="show2 = !show2"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              :style="`color: ${entityConfig.secondaryColor}`"
              @click="post_access_data"
              :disabled="!formIsValid"
              depressed
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.siguiente") }}
            </v-btn>

            <v-btn
              outlined
              @click="volver()"
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.cancelar") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <overlay :visible="spinner" :opacity="0.8"></overlay>
    </v-form>
  </layout-guest>
</template>

<script>
import Overlay from "../../components/layouts/overlay.vue";
import LayoutGuest from "../../components/layouts/layout-guest.vue";
import Progres from "../../components/global/progres_end.vue";

import passwordValidator from "password-validator";
import Api from "../../Services/index";

export default {
  components: {
    Overlay,
    "main-progres": Progres,
    "layout-guest": LayoutGuest,
  },

  data() {
    return {
      show1: false,
      show2: false,
      spinner: false,
      passwordRules: [(v) => !!v || "La contraseña es requerida"],
      confirmPasswordRules: [(v) => !!v || "La confirmacion es requerida"],
      formulario: false,
      form: {
        alias: "",
        codNrbeEn: "",
        email: "",
        languageCode: "ES",
        phone: "",
        principalUser: true,
        supplierId: "",
        password: "",
      },
      entityConfig: {},
      confirmPassword: "",
      rules: {
        referenceValidatorHasalias: (v) => {
          if (this.form.alias) {
            let alias = this.form.alias.toLowerCase().trim();
            return (
              !v.toLowerCase().includes(alias) ||
              "El Password no debe incluir el alias"
            );
          }
          return true;
        },

        ValidatorHasNumber: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(10);
          return schema.validate(v) || "Debe ser numérico";
        },

        referenceValidatorHasNumber: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(1);
          return schema.validate(v) || "Debe ser numérico";
        },

        validatorConsecutivos: (v) =>
          !/(.)\1{2}/.test(v) ||
          "No se permiten mas de 2 caracteres consecutivos",

        validatorSymbolPermitidos: (v) =>
          !/[^\w<>+|&!*%?:. =-]/.test(v) ||
          "Caracteres especiales permitidos: <>+|&!*%?:. =-",

        validatorSymbos: (v) => {
          let schema = new passwordValidator();
          schema.has().symbols();
          return (
            schema.validate(v) ||
            "Debe contener caracteres especiales: <>+|&!*%?:. =-"
          );
        },

        ValidatorUppercase: (v) => {
          var schema = new passwordValidator();
          schema.has().uppercase();
          return (
            schema.validate(v) ||
            "Debe contener al menos 1 caracter en mayuscula"
          );
        },

        ValidatorLowercase: (v) => {
          var schema = new passwordValidator();
          schema.has().lowercase();
          return (
            schema.validate(v) ||
            "Debe contener al menos 1 caracter en minuscula"
          );
        },

        ValidatorHas2Number: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(2);
          return (
            schema.validate(v) || "Debe contener al menos 2 carateres numericos"
          );
        },

        ValidatorHasPhone: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(9);
          return schema.validate(v) || "Debe ser numérico";
        },

        ValidatorNotComillas: (v) => {
          let regex = /["']+/;
          var schema = new passwordValidator();
          schema.has().not(regex);
          return (
            schema.validate(v) ||
            "Las comillas no son tomadas como caracteres validos"
          );
        },

        alias: (v) => {
          if (this.model.alias) {
            let alias = this.model.alias.toLowerCase().trim();
            return (
              !v.toLowerCase().includes(alias) ||
              "El Password no debe incluir el alias"
            );
          }
          return true;
        },
        maxAlias: (v) => v.length <= 9 || "9 caracteres Maximo",
        minAlias: (v) => v.length >= 8 || "8 caracteres minimo",

        maxPass: (v) => v.length <= 30 || "30 caracteres Maximo",
        maxPhone: (v) => v.length <= 9 || "9 caracteres Maximo",
        minPhone: (v) => v.length >= 9 || "9 caracteres Minimo",

        minPass: (v) => v.length >= 12 || "12 caracteres Minimo",

        required: (value) => !!value || "Este campo es requerido..",

        email: (value) => {
          const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
          return pattern.test(value) || "E-mail inválido.";
        },

        minNif: (v) =>
          v.length >= 8 ||
          "La contraseña debe de contener al menos 8 caracteres",

        emailMatch: () => `The email and password you entered don't match`,
      },
    };
  },

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.form.codNrbeEn = sessionStorage.getItem("codNrbeEn");
    this.form.supplierId = sessionStorage.getItem("supplierId");

    if (!/true/i.test(this.$route.query.goBack)) {
      sessionStorage.removeItem("accesDataConfirm");
    }

    let newAccesData = JSON.parse(sessionStorage.getItem("accesDataConfirm"));
    if (newAccesData) {
      this.form = newAccesData;
    }
  },

  computed: {
    passwordConfirmationRule() {
      return () =>
        this.form.password === this.confirmPassword ||
        "Las contraseñas no coincide";
    },

    emailIsValid() {
      return !!this.form.email;
    },

    aliasIsValid() {
      return !!this.form.alias;
    },

    passwordIsValid() {
      return !!this.form.password;
    },

    confirmPasswordIsValid() {
      return !!this.confirmPassword;
    },

    confirmPasswordIgualIsValid() {
      return this.form.newPassword === this.confirmPassword;
    },

    formIsValid() {
      return this.formulario;
    },
  },

  methods: {
    volver() {
      this.$router.push("company-data");
    },
    async post_access_data() {
      this.$router.push("confirmation-data");
      sessionStorage.setItem("accesDataConfirm", JSON.stringify(this.form));
    },
  },
};
</script>
